import type { PluginListenerHandle } from '@capacitor/core';
import type { StatusSCEPlugin } from './StatusSCEPlugin';

export interface CapacitorPluginScePlugin {
  // Connexion & gestion des appareils
  searchDevices(): Promise<void>;
  connectToDevice(options?: { deviceName?: string }): Promise<void>;
  connect(): Promise<void>;
  disconnect(): Promise<void>;
  terminate(): Promise<void>;
  reset(): Promise<{ success: boolean }>;

  // Configuration de l’appareil
  setDeviceId(options: { deviceId: string }): Promise<void>;
  getDeviceId(): Promise<{ deviceId: string }>;
  setPairingCode(options: { pairingCode: string }): Promise<void>;
  setCarrierCode(options: { carrierCode: string }): Promise<void>;

  // Initialisation
  initialize(options: { appVersion: string; env: string }): Promise<void>;

  // Statut
  getStatus(): Promise<StatusSCEPlugin>;

  // Debug & logs
  setDebug(options: { debug: boolean; level?: 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR' }): Promise<{ success: boolean }>;
  eraseLogFiles(): Promise<{ success: boolean }>;

  // Événements
  addListener(
    eventName: 'onEvent',
    listenerFunc: (event: { event: string }) => void
  ): Promise<PluginListenerHandle>;
}
